import { Tag } from 'antd';
import moment from 'moment'

// eslint-disable-next-line no-unused-vars
function onClickEvent (status, activate, cancel, record) {
  // 未激活
  if (status === 0) {
    activate(record);
  } else {
    cancel(record); 
  }
}

function createColumns (activate, cancel) {
  
  const columns = [
    {
      title: 'name',
      render (data) {
        const name = data['name'] || '';
        const store = name.includes('UK') ? 'tenways-uk' : 'tenways10';
        const url = `https://admin.shopify.com/store/${store}/orders/${data['orderId']}`;
        return <a href={url} target='_blank' rel='noreferrer'>{name}｜ {store}</a>
      }
    },
    {
      title: 'Country',
      dataIndex: 'country',
    },
    {
      title: 'Email',
      dataIndex: 'contactEmail'
    },
    {
      title: 'userName',
      dataIndex: 'userName'
    },
    {
      title: 'update time',
      dataIndex: 'updatedAt',
      render: (data) => {
        return moment(data).format('YYYY-MM-DD HH:mm:hh')
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status) => {
        if (status === '0' || status === 0) {
          return <Tag color='#87d068'>normal</Tag>
          
        } else if (status === '1' || status === 1) {
          return <Tag color='#2db7f5'>out of area</Tag>
        } else {
          return <Tag color='#f50'>Error</Tag>
        }
      }
    },
    {
      title: 'Process',
      dataIndex: 'state',
      render: (status) => {
        if (status === '0' || status === 0) {
          return <Tag color='#108ee9'>pending</Tag>
        } else if (status === '1' || status === 1) {
          return <Tag color='#2db7f5'>Partially handoff</Tag>
        } else {
          return <Tag color='#87d068'>Completely handoff</Tag>
        }
      }
    },
    {
      title: 'Referral Code',
      dataIndex: 'referralCode',
    }
  ];
  return columns;
}

export default createColumns;